import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
const SortableItem: React.FunctionComponent = ({ index, row, ...restProps }: any) => {
  const { attributes, listeners, transform, transition, setNodeRef, setActivatorNodeRef } =
    useSortable({ id: row.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const rowAttr: object = { index: index }

  return (
    <tr style={style} ref={setNodeRef} {...rowAttr}>
      <OverlayTrigger
        placement='right'
        delay={{ show: 1250, hide: 100 }}
        overlay={
          <Tooltip>{'Drag and drop this line to change an order of the item in the list'}</Tooltip>
        }
      >
        <td
          {...listeners}
          {...attributes}
          ref={setActivatorNodeRef}
          className='dx-g-bs4-table-cell text-nowrap'
        >
          <span>{'::::'}</span>
        </td>
      </OverlayTrigger>
      {restProps.children}
    </tr>
  )
}

export default SortableItem
